import Topic2Detail from './components/Topic2Detail/Topic2Detail';
import Topic2DetailLayout from './components/Topic2Detail/Topic2DetailLayout';
import TaxonomyListPage from './TaxonomyListPage';

export const TaxonomyWorkspaceRoutePage = () => {
  return <TaxonomyListPage />;
};

export const TaxonomyDetailWorkspaceLayoutRoutePage = () => {
  return <Topic2DetailLayout />;
};

export const TaxonomyDetailWorkspaceRoutePage = () => {
  return <Topic2Detail />;
};
